var _rect, _rect2, _line, _line2, _path, _rect3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorCosmetics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3.27,
    y: 14.467,
    width: 35.459,
    height: 24.754,
    rx: 2.484,
    ry: 2.484
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.717,
    y: 21.91,
    width: 18.566,
    height: 9.868
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 3.27,
    y1: 26.844,
    x2: 11.717,
    y2: 26.844
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30.283,
    y1: 26.844,
    x2: 38.73,
    y2: 26.844
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.935,2.779h6.13c1.146,0,2.077.93,2.077,2.077v5.226h-10.283v-5.226c0-1.146.93-2.077,2.077-2.077Z"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 18.787,
    y: 10.081,
    width: 4.426,
    height: 4.386
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorCosmetics);
export default __webpack_public_path__ + "static/media/indoor-cosmetics.a35b79c374a298042abc4ce0fc5b01cf.svg";
export { ForwardRef as ReactComponent };